import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { useRevealOnScroll } from "../hooks/useRevealOnScroll";
import {
  Code2,
  Smartphone,
  Rocket,
  Palette,
  LayoutDashboard,
  Cog,
  Search,
} from "lucide-react";

const ICONS = [Code2, Smartphone, Rocket, Palette, LayoutDashboard, Cog, Search];

const Services = () => {
  const { t } = useLang();
  const ref = useRevealOnScroll([t]);

  return (
    <section id="services" ref={ref} data-testid="services-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="radial-blob" style={{ width: 600, height: 600, background: "#00F0FF", top: "20%", left: "-15%", opacity: 0.18 }} />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="reveal text-[11px] tracking-[0.3em] uppercase font-bold text-[#00F0FF] mb-4">
          {t.services.overline}
        </div>
        <h2 className="reveal font-heading font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight gradient-text max-w-3xl" data-testid="services-title">
          {t.services.title}
        </h2>
        <p className="reveal mt-5 max-w-2xl text-[#9BA1B0] text-base sm:text-lg font-body">
          {t.services.subtitle}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i] || Code2;
            return (
              <article
                key={i}
                data-testid={`service-card-${i}`}
                className="reveal group relative glass rounded-2xl p-7 md:p-8 hover:-translate-y-1 hover:border-[#00F0FF]/40 transition-all duration-500 overflow-hidden"
              >
                <div
                  className="absolute -top-20 -right-20 w-48 h-48 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-3xl"
                  style={{ background: "radial-gradient(circle, rgba(0,240,255,0.25), transparent 70%)" }}
                  aria-hidden="true"
                />
                <div className="relative">
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br from-[#00F0FF]/15 to-[#0055FF]/15 border border-[#00F0FF]/25 mb-5">
                    <Icon size={22} className="text-[#00F0FF]" strokeWidth={1.6} />
                  </div>
                  <h3 className="font-heading font-semibold text-xl text-white mb-2">{s.title}</h3>
                  <p className="text-sm text-[#9BA1B0] leading-relaxed font-body">{s.desc}</p>
                  <div className="mt-6 flex items-center gap-2 text-[11px] tracking-[0.18em] uppercase font-semibold text-[#00F0FF] opacity-0 group-hover:opacity-100 transition-opacity">
                    <span>0{i + 1}</span>
                    <span className="w-8 h-px bg-[#00F0FF]" />
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
